module.exports = __webpack_public_path__ + "static/hurtigruten_43-660257d5a8efad4eb9093b7223874f34.jpg";